import React from 'react';
import { Link } from 'react-router-dom';
import { STRESS_DISCLAIMER, STRESS_EXERCISES } from '../../utils/stressExercises';
import styles from './Pause.module.css';

const Pause = () => {
  return (
    <section className="main">
      <div className="content-wrapper">
        <div className="page-title-container">
          <h1 className="page-title">Пауза</h1>
        </div>
        <p className={styles.subtitle}>Короткие упражнения, чтобы снять напряжение</p>
        <div className={styles.list}>
          {STRESS_EXERCISES.map((item) => (
            <Link key={item.id} className={styles.card} to={`/pause/${item.id}`}>
              <div className={styles.title}>{item.title}</div>
              <div className={styles.cardSubtitle}>{item.subtitle}</div>
            </Link>
          ))}
        </div>
        <p className={styles.disclaimer}>{STRESS_DISCLAIMER}</p>
      </div>
    </section>
  );
};

export default Pause;
